// icons
import { MdViewKanban } from "react-icons/md";

const kanbanIndividual = {
  id: 'kanban-individual-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'kanban-individual',
      title: 'Kanban individual',
      type: 'item',
      breadcrumbs: false,
      icon: MdViewKanban,
      url: '/kanban-individual'
    }
  ]
};

export default kanbanIndividual;
